import { AxiosError } from "axios";

import { useMutation } from "@tanstack/react-query";

import { useOpenModal } from "@/components/modal/utils/openModal";
import { InfoModalResDto } from "@/models/infoModalRes.dto";

import { ForgotPassApi } from "../api";

export const useSendForgotPassword = () => {
  const { openModal, removeAll } = useOpenModal();
  const openInformationModal = (dto: InfoModalResDto) =>
    openModal("INFORMATION_MODAL", {
      ...dto,
      onOkClick: removeAll,
    });

  const openFailureModal = (dto: InfoModalResDto) =>
    openModal("INFORMATION_MODAL", {
      ...dto,
    });

  return useMutation(ForgotPassApi.send, {
    onSuccess: (data) => {
      openInformationModal(data);
    },
    onError: (error: AxiosError) => {
      openFailureModal({ message: error.message, statusReg: "fail" });
    },
  });
};
